module.exports = __webpack_public_path__ + "img/img-badge.0e423e93.svg";